'use strict';var $TypeError=TypeError;module.exports=function(passed,required){if(passed<required)throw new $TypeError('Not enough arguments');return passed;};